import "Styles/components/session-groups.scss";

class SessionMaterial
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.sessionMaterialKey = options.sessionMaterialKey;
    this.name = options.name;
    this.imageUrl = options.url;
  }

  static createInstance(options)
  {
    let instance = new SessionMaterial(options);
    instance.render();

    return instance;
  }

  render()
  {
    this.hasRendered = false;
    //this.$element = $(HtmlTemplate);

    this.$element = $("<img />", {
      class: "material-icon",
      src: this.imageUrl,
      alt: this.name,
      title: this.name
    });

    this.$container.append(this.$element);
    //LanguageManager.applyLocale(this.$element);

    this.hasRendered = true;
  }

  removeFromContainer()
  {
    this.$element.remove();
  }
}

export default SessionMaterial;



// WEBPACK FOOTER //
// ./app/js/components/session-material.js